var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgULogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8212 2.40597C17.8988 1.78507 18.1317 1.24179 18.5974 0.776119C18.9854 0.388059 19.4511 0.155224 19.9168 0H23.1765V5.35522H20.5377C19.7615 5.35522 19.1406 5.12239 18.675 4.5791C18.2093 4.11343 17.9765 3.57015 17.8988 2.94926V2.40597H17.8212ZM0.979442 0.0776117H4.16153C4.70482 0.155224 5.09288 0.465672 5.48094 0.853732C5.94661 1.3194 6.17944 1.86269 6.25706 2.48358V3.02687C6.17944 3.64776 5.94661 4.19104 5.48094 4.65672C4.93765 5.2 4.31676 5.43284 3.61825 5.43284H0.979442V0.0776117ZM19.9944 22.7403C17.8988 24.9134 15.1824 26 12.0003 26C8.81825 26 6.17944 24.9134 4.00631 22.7403C1.91079 20.5672 0.824219 17.8507 0.824219 14.6687V7.99403H6.17944C6.17944 7.99403 6.17944 15.5224 6.17944 15.6776C6.33467 16.997 6.87795 18.1612 7.88691 19.1701C9.05108 20.3343 10.3705 20.8776 11.9227 20.8776C13.475 20.8776 14.7944 20.3343 15.9585 19.1701C16.6571 18.4716 17.2003 17.6955 17.4332 16.7642C17.5884 16.2209 17.666 15.6776 17.666 15.0567V7.99403H23.0212V14.6687C23.1765 17.8507 22.0899 20.5672 19.9944 22.7403Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULogoNew);
export default __webpack_public_path__ + "static/media/U_logo_new.cadba33785298a9abae28c990fdba8db.svg";
export { ForwardRef as ReactComponent };